/**
 * Query key factory for emails
 *
 * Provides consistent query keys for TanStack Query caching
 */

export interface EmailFilters {
  archived?: boolean;
  includeArchived?: boolean;
  read?: boolean;
  page?: number;
  size?: number;
  search?: string;
}

export const emailKeys = {
  all: ["emails"] as const,
  lists: () => [...emailKeys.all, "list"] as const,
  list: (filters?: EmailFilters) => [...emailKeys.lists(), filters] as const,
  withPreOrders: (filters?: EmailFilters) =>
    [...emailKeys.all, "with-preorders", filters] as const,
  withPreOrdersInfinite: (filters?: EmailFilters) =>
    [...emailKeys.all, "with-preorders-infinite", filters] as const,
  details: () => [...emailKeys.all, "detail"] as const,
  detail: (id: string) => [...emailKeys.details(), id] as const,
  contacts: () => [...emailKeys.all, "contacts"] as const,
  attachment: (emailId: string, filename: string) =>
    [...emailKeys.all, "attachment", emailId, filename] as const,
} as const;
